import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { select } from "@angular-redux/store";
import { Observable } from "rxjs/Observable";
import { ApplicationUser } from "../../pb-screen/models/application.user.interface";
import { filter, switchMap, take } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";


@Component({
    selector: "app-home",
    templateUrl: "./home.component.html"
})
export class HomeComponent implements OnInit {

  @select("applicationUser") private applicationUser$: Observable<ApplicationUser>;

  public isIframe = false;
  public loggedIn = false;

  constructor(
    public readonly titleService: Title,
    private translate: TranslateService
  ) {
  }

  ngOnInit() {
    this.applicationUser$.pipe(
      take(1),
      filter(user => !!user),
      switchMap(() => this.translate.get("PAGE_TITLES.HOME").pipe(take(1)))
    ).subscribe(translation => this.titleService.setTitle(translation));

    this.isIframe = window !== window.parent && !window.opener;
  }
}
